import { LogoIcon } from "@/assets/images";
import { FooterAb } from "@/pages/quiz/base/components/footerAB";

interface IProps {
  onStart: () => void;
}

const CSS_PHONE_DISPLAY = "1 (888) 979-9580";
const CSS_PHONE_TEL = "tel:+18889799580";

const CheckInWelcomeScreen = ({ onStart }: IProps) => {
  return (
    <div className="flex flex-col h-full min-h-[100svh] justify-between">
      <header>
        <div className="h-40 sm:h-60 lg:h-80 bg-light-pink flex justify-center items-start">
          <LogoIcon />
        </div>
      </header>

      <div className="bg-white w-full sm:w-618 p-[16px_16px_24px] sm:p-[30px_75px_60px] sm:drop-shadow-[0_3px_2px_rgba(0,0,0,0.25)] mx-auto mb-20 mt-[-6rem] sm:mt-[-10rem]">
        <h1 className="text-2xl font-semibold text-dark-purple leading-[32px]">
          Welcome to your Monthly Check-In
        </h1>

        <p className="mt-4 text-[17px] leading-6 text-black">
          This is your <span className="font-bold">medical check-in</span>.
          Please use it only to report how you're feeling and any side
          effects.
        </p>
        <p className="mt-4 text-[17px] leading-6 text-black">
          For billing, shipping, or other questions, call Customer Support at{" "}
          <a
            href={CSS_PHONE_TEL}
            className="font-bold text-dark-purple-2 underline"
          >
            {CSS_PHONE_DISPLAY}
          </a>
          .
        </p>

        <button
          type="button"
          onClick={onStart}
          className="mt-6 w-full rounded-full bg-yellow py-5 text-xl font-bold text-black"
        >
          Start Check-In
        </button>
      </div>

      <FooterAb />
    </div>
  );
};

export { CheckInWelcomeScreen };
